var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoint1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-388 -375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.5 19)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(337.5 356)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(392.688 386.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M335.486,220.39l.788-.788,1.515,1.515,2.486-2.486-5.516-5.516-2.486,2.486,1.515,1.515-1.057,1.056a22.734,22.734,0,0,0-11.106-3.889v-1.268h2.344V209.5h-8.2v3.516h2.344v1.246a22.71,22.71,0,0,0-16.686,9.3H293.5v3.516h18.75v-3.516h-6.245a19.331,19.331,0,1,1-3.466,22.066l-.26-.524-3.148,1.564.259.525a22.848,22.848,0,1,0,36.1-26.8Z",
    transform: "translate(-286.469 -209.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M312.072,242.478l2.77-2.77a5.2,5.2,0,0,0,2.26.527,5.28,5.28,0,0,0,5.273-5.273,5.2,5.2,0,0,0-.527-2.261l8.63-8.63-2.486-2.486-8.63,8.63a5.2,5.2,0,0,0-2.26-.527,5.28,5.28,0,0,0-5.273,5.273,5.2,5.2,0,0,0,.527,2.261l-2.77,2.77Zm5.032-5.759a1.758,1.758,0,1,1,1.757-1.759A1.765,1.765,0,0,1,317.1,236.72Z",
    transform: "translate(-283.704 -207.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M306.25,230.281H302a19.141,19.141,0,0,1,1.077-3.417l.227-.539-3.237-1.37-.23.54a22.622,22.622,0,0,0-1.412,4.786H287.5V233.8h18.75Z",
    transform: "translate(-287.5 -206.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M309.078,237.03h-7.739A18.686,18.686,0,0,1,300.9,234l-.032-.585-3.509.192.032.585a22.553,22.553,0,0,0,.337,2.834H291.5v3.516h17.578Z",
    transform: "translate(-286.813 -205.389)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint1);
export default __webpack_public_path__ + "static/media/point1.77728267.svg";
export { ForwardRef as ReactComponent };